import React from 'react'
import { useIntl, FormatDateOptions } from 'react-intl'
import {
  StandingOrderDeliveryType,
  useStandingOrders,
  OrderProductLineItem
} from 'msp-integrations'
import { AccountStandingOrdersStatus } from '../AccountStandingOrdersStatus'
import { Button, DynamicTag } from 'msp-components'
import { translations } from '../AccountStandingOrders.constants'

export const StandingOrdersDetailsDeliveries = ({
  id,
  deliveries,
  products
}: {
  id: string
  deliveries: Array<StandingOrderDeliveryType>
  products: OrderProductLineItem[]
}) => {
  const { formatMessage, formatDate } = useIntl()
  const { suspendDelivery, activateDelivery } = useStandingOrders()
  const dateFormattingOpts = {
    year: 'numeric',
    day: '2-digit',
    month: '2-digit'
  } as FormatDateOptions

  const changeStatus = (delivery: StandingOrderDeliveryType) => {
    if (delivery.status == 1) {
      return suspendDelivery(id, delivery.id)
    } else {
      return activateDelivery(id, delivery.id)
    }
  }

  return (
    <>
      <DynamicTag componentTagName='Headline' tag='h6' className='mb-4'>
        {formatMessage(translations.detailOverviewDeliveries)}
      </DynamicTag>
      <div className='font-Roboto text-14 flex flex-row'>
        <div className='flex-[0_1_25%] pl-2 font-bold'>
          {formatMessage(translations.detailDeliveriesLabelDate)}
        </div>
        <div className='flex-[0_1_15%] font-bold md:flex-[0_1_25%]'>
          {formatMessage(translations.detailDeliveriesLabelStatus)}
        </div>
        <div className='flex-[0_0_30%] font-bold md:flex-[0_1_25%]'>
          {formatMessage(translations.detailDeliveriesLabelItem)}
        </div>
        <div className='flex-[0_0_30%] md:flex-[0_1_25%]'></div>
      </div>
      {deliveries?.map((delivery: StandingOrderDeliveryType) => (
        <div
          key={delivery.id}
          className='font-Roboto text-14 font-regular border-machine2-75 flex items-center border-b px-0 py-2'
        >
          <div className='flex-[0_1_25%] py-2'>
            {formatDate(delivery.shippingDate, dateFormattingOpts)}
          </div>
          <div className='flex-[0_1_15%] md:flex-[0_1_25%]'>
            <AccountStandingOrdersStatus status={delivery.status} />
          </div>
          <div className='flex flex-[0_1_30%] flex-row md:flex-[0_1_25%]'>
            {products?.map((p, i) => (
              <img
                key={`img_${p.id}_${i}`}
                height='30px'
                width='30px'
                src={p?.c_image}
                alt={p?.name}
              />
            ))}
          </div>
          <div className='flex-[0_0_30%] md:flex-[0_1_25%] lg:pl-2'>
            <Button
              className='w-full'
              variant='outline'
              type='secondary'
              uppercase={false}
              className='max-md:px-1'
              onClick={() => changeStatus(delivery)}
            >
              {formatMessage(
                delivery.status == 1
                  ? translations.detailDeliveriesSuspend
                  : translations.detailDeliveriesActivate
              )}
            </Button>
          </div>
        </div>
      ))}
    </>
  )
}
